import api from '@/api';

export const stratigraphyOrder = [
    'stratigraphy_system',
    'stratigraphy_department',
    'stratigraphy_tier',
    'stratigraphy_overhorizon',
    'stratigraphy_horizon',
];

export const stratigraphyModel = {
    state: {
        data: {},
        error: false,
        loading: false,
    },
    reducers: {
        setStratigraphy: (state, payload) => {
            return { ...state, data: { ...state.data, [payload.id]: payload.data } };
        },
        setError: (state, payload) => {
            return { ...state, error: payload };
        },
    },
    effects: () => ({
        async loadStratigraphy(wellId) {
            try {
                const data = await api.carottage.fetchStratigraphy({
                    wellIds: [wellId],
                });

                const res = {};

                data.forEach(u => {
                    if (!res[u.start_unit_group]) {
                        res[u.start_unit_group] = [u];
                    } else {
                        res[u.start_unit_group] = [...res[u.start_unit_group], u];
                    }
                });

                this.setStratigraphy({ id: wellId, data: res });
            } catch (error) {
                this.setError(error);
            }
        },
    }),
};
